export default __webpack_public_path__ + "static/media/position-share-bg.28147bc8.png";